import React from 'react'
import styled from 'styled-components'
import { inboxSkeletonSurface } from '../skeleton/inboxSkeletonStyles'

const ConversationPreloader: React.FC = () => (
    <Container>
        <Photo />
        <Content>
            <LineShort />
            <LineLong />
        </Content>
    </Container>
)

const Container = styled.div`
    display: flex;
    align-items: center;
    padding: 15px;
    margin-bottom: 2px;
`

const Photo = styled.div`
    width: 40px;
    height: 40px;
    border-radius: 50%;
    flex-shrink: 0;
    ${inboxSkeletonSurface}
    margin-right: 12px;
`

const Content = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 8px;
`

const LineShort = styled.div`
    height: 14px;
    width: 60%;
    ${inboxSkeletonSurface}
    border-radius: 4px;
`

const LineLong = styled.div`
    height: 12px;
    width: 85%;
    ${inboxSkeletonSurface}
    border-radius: 4px;
`

export default ConversationPreloader
